<template>
  <loadable :loading="isBusy" size="small" class="delegations mt-5">
    <template v-if="!delegation">
      <v-list dense v-if="delegations && delegations.length > 0">
        <v-subheader>{{ $t('delegations.title') }}</v-subheader>
        <v-list-tile v-for="delegation in delegations" :key="delegation._self" @click="select(delegation)">
          <v-list-tile-action>
            <v-icon>open_in_browser</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ delegation.company.name }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </template>
    <template v-else>
      <v-layout row align-center class="active-delegation">
        <v-flex px-2><v-icon class="blue--text">info</v-icon></v-flex>
        <v-flex class="delegation-info" >
          <div class="grey--text">{{ $t('delegations.delegatedAs') }}</div>
          <div class="blue--text text--lighten-1">{{ delegation.company.name }}</div>
        </v-flex>
        <v-flex><v-btn flat error @click="select(null)">{{ $t('cancel') }}</v-btn></v-flex>
      </v-layout>
    </template>
  </loadable>
</template>

<script>
import User from '@/models/User'
import CompanyDelegation from '@/models/CompanyDelegation'

import moment from 'moment'

export default {
  data () {
    return {
      delegations: [],
      delegation: null,
      isBusy: false
    }
  },
  created () {
    User
      .getDelegation(this.$store.auth.user, { include: ['company'] })
      .then(result => {
        this.delegation = result
      })
      .catch(err => {
        if (err && err.response && err.response.status !== 404) {
          console.error('Failed to fetch company delegations for delegations menu')
          console.error(err)
        }
      })

    CompanyDelegation
      .getList({ include: ['company'] })
      .then(result => {
        let now = moment()

        this.delegations = result.items.filter(delegation => {
          let from = moment(delegation.dateFrom)
          let to = from.clone().add(delegation.duration, 'minutes')

          // Currently enabled, show normally, hide after expiry
          if (now.isBetween(from, to)) {
            setTimeout(() => {
              this.delegationExpired(delegation)
            }, now.diff(to, 'seconds') * 1000)

            return true
          }

          // Will become enabled in some time, set timeout to display it
          if (now.isAfter(from)) {
            setTimeout(() => {
              this.delegationEnabled(delegation)
            }, from.diff(now, 'seconds') * 1000)
          }

          // Expired, hide forever
          return false
        })
      })
  },
  methods: {
    select (delegation) {
      this.isBusy = true

      let updated = { ...this.$store.auth.user }
      updated.companyDelegation = delegation || {
        _self: null
      }

      return User
        .applyRelations(updated)
        .then(() => {
          this.delegation = delegation

          this.$store.auth.user.company = delegation ? delegation.company : null
          this.$store.auth.user.companyDelegation = delegation

          this.isBusy = false
          this.$emit('change', delegation)
        }, () => {
          this.isBusy = false
        })
    },

    delegationEnabled (delegation) {
      this.delegations.push(delegation)
    },

    delegationExpired (delegation) {
      this.delegations.filter(item => item.id !== delegation.id)
      if (this.delegation && this.delegation.id === delegation.id) {
        this
          .select(null)
          .then(() => {
            alert(this.$t('delegations.expiredAlert'))
          })
      }
    }
  }
}
</script>

<style>
.active-delegation {
  background: #444;
}
</style>



// WEBPACK FOOTER //
// Delegations.vue?6f38963a